export enum AuthMode {
  LOGIN = 'login',
  SIGNUP = 'signup',
}

export enum LoginStep {
  AUTH = 'auth',
  OTP = 'otp',
  EMAIL_SELECTION = 'emailSelection',
  USER_INFO = 'userInfo',
  WELCOME = 'welcome',
}

export const LOGIN_STEPS = [
  LoginStep.AUTH,
  LoginStep.OTP,
  LoginStep.EMAIL_SELECTION,
  LoginStep.USER_INFO,
  LoginStep.WELCOME,
] as const;

